export default __webpack_public_path__ + "static/media/freezer-closed.0e9f657b.svg";